import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import AppText from "../../components/Core/AppText/AppText";
import AppIcon from "../../components/Core/AppIcon/AppIcon";
import { OtherDocumentsByType as DocumentByType } from "../../models/Consultant";

interface DocumentCheckListProps {
	heading: string;
	documentsByType: DocumentByType;
}

export interface ListStyleProps {
	status?: boolean;
}

const DocumentCheckList: React.FC<DocumentCheckListProps> = ({ heading, documentsByType }) => {
	const { t } = useTranslation();

	return (
		<ListWrapper>
			<AppText size="xm" weight="bold" color="grayTextLight">
				{heading}
			</AppText>
			<ul>
				{Object.entries(documentsByType).map(([key, { include }]) => (
					<ListStyles key={key} status={include}>
						<AppIcon icon={include ? "blue-check" : "red-cross"} size="8px"></AppIcon>
						{t(key as any)}
					</ListStyles>
				))}
			</ul>
		</ListWrapper>
	);
};

export default DocumentCheckList;

const ListWrapper = styled.div`
	display: flex;
	flex-direction: column;

	ul {
		margin-top: 27px;
		list-style: none;
	}
`;

const ListStyles = styled.li<ListStyleProps>`
	color: ${(props) =>
		props.status ? props.theme.colors.COLOR_BLACK : props.theme.colors.COLOR_GRAY_TEXT_LIGHT};
	display: flex;
	align-items: center;
	font-size: 0.9375rem;
	margin-bottom: 29px;

	&:last-child {
		margin-bottom: 0;
	}
`;
